import React, { useMemo, useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Card } from "react-bootstrap";
import { shallowEqual, useSelector } from "react-redux";
import SuccessModal from "../../Modal/SuccessModal";
import { TransactionsReportFilter } from "./transactions-report-filter/TransactionsReportFilter";
import { TransactionsReportTable } from "./transactions-report-table/TransactionsReportTable";
import { useTransactionsReportUIContext } from "./TransactionsReportUIContext";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

export function TransactionsReportCard({}) {
  const myRef = useRef(null);
  const [isSuccessModalShow, setSuccessModal] = useState(false);
  const onhandleReset = () => {
    myRef.current.click();
  };

  const { currentState } = useSelector(
    (state) => ({ currentState: state.transactionsReport }),
    shallowEqual
  );

  const { actionsLoading, xlsFilename } = currentState || {};

  useEffect(() => {
    if (xlsFilename) {
      handleSuccessModalShow();
    }
  }, [xlsFilename]);

  const handleSuccessModalShow = () => {
    setSuccessModal(true);
  };

  const handleSuccessModalHide = () => {
    setSuccessModal(false);
  };

  const transactionsReportUIContext = useTransactionsReportUIContext();
  const transactionsReportUIProps = useMemo(() => {
    return {
      handleExportButton: transactionsReportUIContext.handleExportButton
    };
  }, [transactionsReportUIContext]);

  return (
    <>
      <Card className="card-custom card-stretch make-payment-wrapper">
        <Card.Header className="align-items-center border-bottom mt-4  d-lg-flex">
          <h3 className="card-title align-items-start flex-column">
            <span className="font-weight-bold text-dark">
              Transactions Report
            </span>
          </h3>
          <button
            type="button"
            className="btn btn-secondary btn-lg"
            // disabled={false}
            onClick={onhandleReset}
          >
            Reset
          </button>
          <button
            className="btn btn-light-primary btn-lg"
            disabled={false}
            onClick={() => {
              transactionsReportUIProps.handleExportButton();
            }}
          >
            Export
            {actionsLoading && (
              <span className="ml-1 mr-3 spinner spinner-white"></span>
            )}
          </button>
        </Card.Header>
        <Card.Body>
          <TransactionsReportFilter myRef={myRef} />
          <TransactionsReportTable />
        </Card.Body>
      </Card>
      {isSuccessModalShow && (
        <SuccessModal
          message={
            "Your export has been successfully scheduled. Download the export file from mail - 'admin@payxtreme.com'"
          }
          isConfirmModal={isSuccessModalShow}
          handleConfirmHide={handleSuccessModalHide}
          successIcon={
            <div className="success-icon-wrapper text-center">
              <span className="svg-icon menu-icon svg-icon-white svg-icon-4x mr-0">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Navigation/Check.svg")}
                />
              </span>
            </div>
          }
        />
      )}
    </>
  );
}
